import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTypeItalic = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.7793 23V20.5H13.7793L16.7793 11.5H12.7793V9H22.7793V11.5H19.2793L16.2793 20.5H19.7793V23H9.7793Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgTypeItalic);
const Memo = memo(ForwardRef);
export { Memo as ReactComponent };
